export * from "./SettingsPage";
